import { LocalStorage } from '@ztechapps/common.utils'
import { storageKeys } from '../../config/StorageKeys'

/**
 * Whether a signed-in session exists on this device, read directly from local storage.
 * Call this only from an event handler, never during render — the token invoice route's
 * Apollo client deliberately carries no access token (PII-driven anonymity), so computing
 * this at render time would reintroduce the SSR/hydration mismatch `useUser.ts`'s own
 * comment warns about. Mirrors the direct local-storage read `useOrderSignInGuard` already
 * uses on this same anonymous-route family, without calling or extending that guard.
 */
export const hasLocalSession = (): boolean => Boolean(new LocalStorage().get(storageKeys.userId))
